import { simplePath } from "../utils.js";
const POST_INVITE_PEOPLE_PATH = "/v2/people/:organization/invite";
function post_invite_people_path(params) {
    return simplePath(POST_INVITE_PEOPLE_PATH, params);
}
export { POST_INVITE_PEOPLE_PATH, post_invite_people_path };
